<template>
    <div>
        <v-content-layout>
            <template #header>
                <div>
                    <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
                </div>
                <v-spacer></v-spacer>
                <el-button icon="mdi mdi-upload" type="primary" @click="handleModalView">Import</el-button>
                <el-button class="ml-2" icon="mdi mdi-refresh" type="success" @click="loadParserResults"> Refresh</el-button>
            </template>
            <template #body>
                <e-table :data="items" :total="items.length" :headers="headers" :search="search" :height="window.height - 170" :loading="loading">
                    <template #actions="{scope}">
                        <span v-if="scope.row.status === 1">-</span>
                        <el-dropdown size="mini" v-else trigger="click" split-button type="primary" @click="handleDownload(scope.row.file_link)">
                            Download Result
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-download" @click.native="handleDownload(`https://invoice-audit.s3.amazonaws.com/${scope.row.file_name}`)">Download Original File</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </template>
                </e-table>
            </template>
        </v-content-layout>
        <ImportForm ref="importFormDialog" @onSuccess="onImportSuccess" />
    </div>
</template>

<script>
import api from '@/services/api'
import ImportForm from './components/ImportForm';
import moment from 'moment'
export default {
    components: { ImportForm },
    data: () => ({
        
        items:[],
        headers:[
            { text: 'Parsed Date', value: 'uploaded_at', sortable: true, formatter: (row) => moment(row.uploaded_at).utcOffset('+08:00').format('MM/DD/YYYY, hh:mm A'), align: 'center'},
            { text: 'Parsed By', value: 'currentUser', sortable: true, align: 'center' },
            { text: 'Batch ID', value: 'batchId', sortable: true, align: 'center' },
            { text: 'Brand', value: 'brandName', sortable: true, align: 'center' },
            { text: 'Type', value: 'requestType', sortable: true, align: 'center' },
            { text: 'Status', value: 'status', sortable: true, formatter: (row) => row.status === 0 ? 'Queued' : row.status === 1 ? 'Parsing' : row.status === 2 ? 'Completed' : '', align: 'center'},
            { text: 'Actions', value: '', align: 'center', alignHeader: 'center', width: '200' }
        ],
        search: '',
        loading: false
    }),
    created(){
        this.loadParserResults()
    },
    methods: {
        handleModalView() {
            this.$refs['importFormDialog'].handleModalView()
        },
        handleDownload(url){
            window.open(url, "_blank")
        },
        async loadParserResults(){
            this.loading = true
            try{
                let response = await api.get('/nodeparser')
                this.items = response.data
            }catch(error){
                console.log(error)
            }finally{
                this.loading = false
            }
        },
        onImportSuccess(data){
            
            this.loadParserResults()
        }
    }
}
</script>